import { requestApi } from '../Api';

export const listSpecialty = (navigate, params) => {
  return requestApi({ url: '/api/practitioner/specialty/list', params, navigate });
};

export const createSpecialty = (navigate, params) => {
  return requestApi({ url: '/api/practitioner/specialty/create', params, navigate });
};

export const updateSpecialty = (navigate, params) => {
  return requestApi({ url: '/api/practitioner/specialty/update', params, navigate });
};

export const deleteSpecialty = (navigate, params) => {
  return requestApi({ url: '/api/practitioner/specialty/delete', params, navigate });
};
